/**
 * Query keys for user Patient Info data.
 */
export const userInfoKeys = {
  all: ['user-info'] as const,
  byUser: (userId: string) => ['user', userId, 'info'] as const,
};
